/**
 * お問い合わせページのハッシュフラグメントによるリダイレクト処理
 *
 * 旧フォームのハッシュフラグメントを検出して、
 * 適切な個別お問い合わせページにリダイレクトする
 *
 * 注意: JavaScriptでの301リダイレクトは不可能
 * ハッシュフラグメントはサーバーに送信されないため、
 * JavaScriptでのクライアントサイドリダイレクトが必要
 *
 * ただし、history.replaceState()を使用して履歴を置き換え、
 * 検索エンジンにはcanonicalタグで正しいURLを伝える
 */
export class ContactHashRedirect {
  private hashToUrlMap: { [key: string]: string } = {
    'enquiryCategoryCatalog': '/contact/catalog/',
    'enquiryCategoryProduct': '/contact/product/',
    'enquiryCategoryContract': '/contact/business/',
    'enquiryCategoryMaintenance': '/contact/maintenance/',
    'enquiryCategoryOther': '/contact/other/'
  };

  constructor() {
    this.init();
  }

  private init(): void {
    // ハッシュフラグメントをチェック
    const hash = window.location.hash.replace('#', '');

    if (!hash) {
      return;
    }

    // ハッシュに対応するURLがあればリダイレクト
    const redirectUrl = this.hashToUrlMap[hash];

    if (redirectUrl) {
      console.log(`Redirecting from hash #${hash} to ${redirectUrl}`);

      // 履歴を置き換えて、ブラウザの戻るボタンで元のURLに戻らないようにする
      // これにより301リダイレクトに近い動作を実現
      if (window.history && window.history.replaceState) {
        window.history.replaceState(null, '', redirectUrl);
      }

      // ページ遷移
      window.location.replace(redirectUrl);
    }
  }
}
